import React from 'react';
import { useTranslation } from 'react-i18next';
import NavMenu from './NavMenu';
import HamburgerMenu from './HamburgerMenu';
import LanguageDropdown from './LanguageDropdown';
import logo from '../assets/images/logo1-büyük.png';
import '../styles/Navbar.css';

const Navbar = () => {
  const { t } = useTranslation();

  const handleLogoClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="Owlex Logo" />
        </div>

        {/* Nav Menu - Desktop */}
        <NavMenu />

        {/* Language Dropdown, Hamburger Menu ve Try Demo Button */}
        <div className="navbar-actions">
          <LanguageDropdown />
          <HamburgerMenu />
          <button className="try-demo-btn">
            <span className="btn-text">{t('navbar.tryDemo')}</span>
            <span className="btn-arrow">→</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;

